var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5188 0C16.289 0 0 16.289 0 36.5188V163.481C0 183.711 16.289 200 36.5188 200H105.331V121.813H84.6564V93.6626H105.331V69.6126C105.331 50.7176 117.547 33.3688 145.688 33.3688C157.081 33.3688 165.506 34.4626 165.506 34.4626L164.844 60.7502C164.844 60.7502 156.251 60.669 146.875 60.669C136.727 60.669 135.1 65.3446 135.1 73.1066V93.6628H165.65L164.319 121.813H135.1V200H163.481C183.711 200 200 183.711 200 163.482V36.519C200 16.2892 183.711 0.0002 163.481 0.0002H36.5186L36.5188 0Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceLink);
export default __webpack_public_path__ + "static/media/faceLink.9d8df3d13ff7c798fc323322014c08fa.svg";
export { ForwardRef as ReactComponent };